import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { colors, fontFamilies } from '../../search-common/settings'
import { ratio, getSpaceAreaRange } from '../../search-common/helpers'

const Container = styled.div`
  width: 250px;
  background-color: ${colors.grayTone2};

  &:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-top-color: ${colors.grayTone2};
    border-width: 6px;
    margin-left: -6px;
  }
`

const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  background-color: ${colors.white};
  border: none;
  border-radius: 100%;
  width: 32px;
  height: 32px;
  font-size: 20px;
  line-height: 1;
  text-align: center;
  z-index: 1;
  cursor: pointer;
`

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: ${ratio( 1, 0.8 )}%;
`

const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Content = styled.div`
  padding: 16px;
`

const StreetAddress = styled.h3`
  font-family: ${fontFamilies.aeonik};
  font-size: 20px;
  font-weight: bold;
  color: ${colors.white};
`

const SpaceArea = styled.div`
  font-family: ${fontFamilies.aeonik};
  font-size: 16px;
  color: ${colors.white};
  margin-bottom: 12px;
`

const Location = styled.div`
  font-family: ${fontFamilies.aeonik};
  font-size: 16px;
  color: ${colors.black};
  margin-bottom: 12px;
`

const BuildingName = styled.span`
  background-color: ${colors.blackTwo};
  font-family: ${fontFamilies.aeonik};
  font-size: 13px;
  font-weight: bold;
  color: ${colors.white};
  padding: 6px 12px;
  text-transform: uppercase;
  z-index: 1;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`

const Link = styled.a`
  text-decoration: none;
`

/**
 * MapCard component.
 */
const MapCard = ({ resultItem, closeHandler, images }) => (
  <Container>
    <CloseButton onClick={closeHandler}>{'×'}</CloseButton>
    <Link href={`/property/${resultItem.slug}`}>
      <ImageContainer>
        {images.length > 0
          ? <Image className='lazyload' src={images[0].src} data-srcset={images[0].srcset} data-sizes='auto' />
          : null
        }
        {resultItem.name
          ? <BuildingName>{resultItem.name}</BuildingName>
          : null
        }
      </ImageContainer>
    </Link>
    <Content>
      <Link href={`/property/${resultItem.slug}`}>
        <StreetAddress>{resultItem.address}</StreetAddress>
      </Link>
      <SpaceArea>{getSpaceAreaRange( resultItem.spaces )}</SpaceArea>
      <Location>{resultItem.neighborhood},<br />{resultItem.zip_code} {resultItem.city}</Location>
    </Content>
  </Container >
)

MapCard.propTypes = {
  resultItem: PropTypes.object,
  closeHandler: PropTypes.func,
  images: PropTypes.array
}

export default MapCard
